import React from 'react';
import SocialBoostQuote from './SocialBoostQuote';

var createReactClass = require('create-react-class');

const Main = createReactClass({
  getInitialState: function() {
    return {
      users: this.props.users,
      start: 0,
    }
  },

  renderUser: function() {
    return <SocialBoostQuote user={this.props.users[this.state.start]} handleNext={this.handleNext}/>
  },

  handleNext: function(dir) {
    var start = this.state.start
    var length = this.state.users.length
    if (dir === 'left') {
      start = start - 1
      if(start < 0) {
        start = length + start
      }
    } else if (dir === 'right'){
      start = start + 1
      if(start >= length) {
        start = start - length
      }
    }
    this.setState({start: start})
  },

  render: function(){
    return (
      <React.Fragment>
          <div className="row">
            <div className="large-10 large-offset-1 medium-12 small-12 columns flex-container">
              <div className="medium-12 large-12 small-12 columns">
                <div className="quote-carousel-container">
                  {this.renderUser()}
                </div>
              </div>
            </div>
          </div>
          <div className="row show-for-medium-down">
            <div className="small-12 columns">
              <div className="channel-carousel-arrow-container">
                <i className="far fa-arrow-alt-circle-left"  onClick={() => this.handleNext('left')}></i>
                <i className="far fa-arrow-alt-circle-right" onClick={() => this.handleNext('right')}></i>
              </div>
            </div>
          </div>
      </React.Fragment>
    );
  }
})

export default Main